import {
  Box, Button, CircularProgress, Grid, TextField, Typography
} from '@material-ui/core';
import { TransactionReject } from 'components/ui/TransactionReject';
import { useAsync } from 'hooks/useAsync';
import { TransactionDetails } from 'models';
import React, { memo, useEffect, useState } from 'react';
import { transactionService } from 'services/transactionService';
import { formatOneTimeCode } from 'utils/otcFormatter';

export const Reject = memo(() => {
  const [oneTimeCode, setOneTimeCode] = useState('');
  const [resolvedDetails, setResolvedDetails] = useState<TransactionDetails | null>(null);

  const resolve = useAsync(() => transactionService.resolveRejectionOtc(oneTimeCode));

  useEffect(() => {
    if (resolve.isSuccess && resolve.data) {
      setResolvedDetails(resolve.data);
    }
  }, [resolve.isSuccess, resolve.data]);

  if (resolvedDetails) {
    return (
      <Grid container direction="row" justify="center" alignItems="baseline">
        <Grid item sm={12} md={8}>
          <TransactionReject
            transactionId={resolvedDetails.id}
            oneTimeCode={oneTimeCode}
            transactionDetails={resolvedDetails}
          />
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container direction="row" justify="center" alignItems="baseline">
      <Grid item sm={12} md={6}>
        <Box pt={4}>
          <Typography variant="h4" gutterBottom>
            Reject transaction
          </Typography>
          <Typography variant="body1" gutterBottom>
            Please enter the one-time cancellation code from your notification email or SMS.
          </Typography>
          <Box pt={2}>
            <TextField
              label="One-time cancellation code"
              placeholder="XXXX-XXXX"
              variant="outlined"
              fullWidth
              value={oneTimeCode}
              onChange={e => setOneTimeCode(formatOneTimeCode(e.target.value))}
              inputProps={{ maxLength: 9 }}
              disabled={resolve.isLoading}
            />
          </Box>
          {resolve.isError && resolve.error && (
            <Box pt={1}>
              <Typography variant="body2" color="error">
                {resolve?.error?.data?.[0]?.description ?? 'Invalid or expired one-time code. Please try again.'}
              </Typography>
            </Box>
          )}
          <Box pt={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => resolve.exec()}
              disabled={resolve.isLoading || oneTimeCode.trim().length === 0}
              endIcon={resolve.isLoading && <CircularProgress size="1rem" color="inherit" />}
            >
              Continue
            </Button>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
});
